import otpNoCodeController from "./otpNoCodeController";

var otpService = function ($modal) {
    var service = {};
    service.modalInstance = null;

    service.openOTPNoCodeModalModal = function () {
        service.modalInstance = $modal.open({
            template:
                '<pwr-otp-nocode-modal-component options="ctrl.options"></pwr-otp-nocode-modal-component>',
            controller: otpNoCodeController,
            controllerAs: "ctrl",
            size: "md",
            windowClass: "modal-wrapper"
        });
    };

    return service;
};

otpService.$inject = ["$modal"];
export default otpService;
